import { attachmentsApi } from './queries/attachments'
import { authApi } from './queries/auth'
import { cartApi } from './queries/cart'
import { claimRecordsApi } from './queries/claimRecords'
import { configApi } from './queries/config'
import { insurersApi } from './queries/insurers'
import { sessionsApi } from './queries/sessions'
import {
  cancelClaimSlice,
  claimStatusSlice,
  prescriptionFileSlice,
  workflowSlice,
  ctaSlice,
  analyticsSlice,
  connectorSlice,
  formsSlice,
  claimSubmitSlice,
  overviewWidgetSlice,
} from './slices'

export const reducers = {
  [authApi.reducerPath]: authApi.reducer,
  [insurersApi.reducerPath]: insurersApi.reducer,
  [claimRecordsApi.reducerPath]: claimRecordsApi.reducer,
  [sessionsApi.reducerPath]: sessionsApi.reducer,
  [configApi.reducerPath]: configApi.reducer,
  [attachmentsApi.reducerPath]: attachmentsApi.reducer,
  [cartApi.reducerPath]: cartApi.reducer,
  [prescriptionFileSlice.name]: prescriptionFileSlice.reducer,
  [cancelClaimSlice.name]: cancelClaimSlice.reducer,
  [claimStatusSlice.name]: claimStatusSlice.reducer,
  [claimSubmitSlice.name]: claimSubmitSlice.reducer,
  [workflowSlice.name]: workflowSlice.reducer,
  [ctaSlice.name]: ctaSlice.reducer,
  [analyticsSlice.name]: analyticsSlice.reducer,
  [connectorSlice.name]: connectorSlice.reducer,
  [formsSlice.name]: formsSlice.reducer,
  [overviewWidgetSlice.name]: overviewWidgetSlice.reducer,
}

export const initialState = {
  [prescriptionFileSlice.name]: prescriptionFileSlice.getInitialState(),
}
